import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import AOS from 'aos'
import Icon from '../../../../components/icons'
import Text from '../../../../elements/Typo/Text'
import { EXPERIMENT_PROGRESS_STATUS } from '../../../../_config'
import { formatNumberWithCommas, KMBformatNumber } from '../../../../_common/functions'
import { CardI } from './Cards'

interface Props {
    cardDetails: CardI | null
    experiment?: any
}

const HeaderCardsMini: React.FC<Props> = ({ cardDetails = null, experiment }) => {
    const { t } = useTranslation()
    useEffect(() => {
        AOS.init({
            once: false, // Animation occurs every time you scroll to the element
        })
        AOS.refresh()
    }, [])
    const isPositiveOrInconclusive = cardDetails?.experiment_status === EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT || cardDetails?.experiment_status === EXPERIMENT_PROGRESS_STATUS.INCONCLUSIVE
    const [confidence, setConfidence] = useState<string>('')
    const iconName = isPositiveOrInconclusive ? 'upFilled' : 'downFilled'

    // Determine icon class
    let iconClass = ''

    if (cardDetails?.experiment_status === EXPERIMENT_PROGRESS_STATUS.POSITIVE_LIFT) {
        iconClass = 'bg-[#2EA87C] text-white'
    } else if (cardDetails?.experiment_status === EXPERIMENT_PROGRESS_STATUS.NEGATIVE_LIFT) {
        iconClass = 'bg-[#921A28] text-white'
    } else {
        iconClass = 'bg-[#c9b802] text-black'
    }

    useEffect(() => {
        if (cardDetails && experiment) {
            if (Number(Number(cardDetails?.confidence_level).toFixed(2)) >= 100) {
                setConfidence('99.9%')
            } else {
                setConfidence((cardDetails?.confidence_level ? Number(cardDetails?.confidence_level).toFixed(2) : 0) + '%')
            }
        }
    }, [cardDetails, experiment])

    return (
        <div className="grid grid-cols-10 gap-1" data-aos="zoom-in" data-aos-delay="200">
            <div className="col-span-3 flex items-center justify-between rounded-[0.591rem] bg-[#F5E003] py-[0.182rem] px-[0.455rem] gap-1">
                <div className="flex items-center">
                    <Text size="md" className="font-bold !text-[0.591rem]">
                        {t('Uplift')}
                    </Text>
                    &nbsp;
                    <Icon name={iconName} className={`rounded-full ${iconClass}`} size={'0.909rem'}></Icon>
                </div>
                <Text size="lg1" className="font-bold truncate" title={cardDetails ? `${formatNumberWithCommas(+Number.parseFloat('' + cardDetails?.uplift).toFixed(2))}%` : t('N/A')}>
                    {cardDetails?.uplift == null ? t('N/A') : `${formatNumberWithCommas(+Number.parseFloat(String(cardDetails.uplift)).toFixed(2))}%`}
                </Text>
            </div>

            <div className="col-span-4 rounded-[0.591rem] bg-[#F5E003] py-[0.182rem] px-[0.455rem] gap-1">
                <div className="flex items-center justify-between">
                    <Text size="md" className="font-bold !text-[0.591rem] truncate" title={cardDetails?.kpi_name || '-'}>
                        {t('KPI Impact')}
                    </Text>
                    <Text size="lg1" className="font-bold truncate" title={cardDetails ? `${KMBformatNumber(cardDetails?.kpi_impact_value)}` : t('N/A')}>
                        {cardDetails?.kpi_impact_value == null ? t('N/A') : KMBformatNumber(cardDetails?.kpi_impact_value)}
                    </Text>
                </div>
                <Text size="sm" className="font-bold truncate" title={cardDetails?.kpi_name || '-'}>
                    ({cardDetails?.kpi_name || '-'})
                </Text>
            </div>
            <div className="col-span-3 flex items-center justify-between rounded-[0.591rem] bg-[#F5E003] py-[0.182rem] px-[0.455rem] gap-1">
                <div className="">
                    <Text size="md" className="font-bold !text-[0.591rem]">
                        {t('Confidence')}
                    </Text>
                    <Text className="font-bold text-[0.8rem]">{confidence}</Text>
                </div>
            </div>
        </div>
    )
}
export default HeaderCardsMini
